<template>
  <v-btn
    v-if="mustShowSubscriptionBtn"
    color="orange"
    elevation="1"
    to="/app/plans"
    v-html="subscriptionBtnText"
    small
  />
</template>
includes(this.$subsMng.subscriptionPlan["ab_subscription_plan"], "TRIAL")
<script>
  import moment from "moment"
  import {includes} from "lodash/collection"

  export default {
    name: "SubscriptionButton",
    data: () => ({
      btnText: null,
      isLoading: true,
    }),
    computed: {
      mustShowSubscriptionBtn() {
        if (this.isLoading) return false
        if (this.$vuetify.breakpoint.xsOnly) return false
        if (this.$subsMng.isSubscriptionEmpty) return true
        if (includes(this.$subsMng.subscriptionPlan["ab_subscription_plan"], "TRIAL")) return true
        return !this.$subsMng.subscription["bl_activated"];
      },
      subscriptionBtnText() {
        if (this.$subsMng.isSubscriptionEmpty) return `Você não possui assinatura, <b>Assine agora</b>`

        if (includes(this.$subsMng.subscriptionPlan["ab_subscription_plan"], "TRIAL")) {
          const dtDue = moment(this.$subsMng.subscription["dt_due"], moment.ISO_8601).add(1, 'days')
          const dtNow = moment(new Date(), moment.ISO_8601)
          const remainingDays = dtDue.diff(dtNow, "days")
          if (remainingDays > 0) return `${remainingDays} dias restantes, <b>Assine agora</b>`
          else return `Sua assinatura expirou, <b>Assine agora</b>`
        }

        if (!this.$subsMng.subscription["bl_activated"]) return `Sua assinatura expirou, <b>Assine agora</b>`

        return ""
      }
    },
    created() {
      this.isLoading = true
      this.$subsMng.getSubscription(this.$apiAuth.getAuthToken())
        .then(() => {
          this.isLoading = false
        })
    }
  }
</script>

<style scoped>

</style>
